import { Card, CardProps, Divider, Grid, Typography, styled } from '@mui/material'
import React from 'react'
import { PoiExtendedDto, PoiType } from '../api/app.generated'
import { useTranslation } from 'react-i18next';

export interface WastePointListItemProps {
    wastePointItem: PoiExtendedDto,
    isSelected: boolean,
}

interface StyledCardProps extends CardProps {
     isSelected: boolean;
}

const StyledCard = styled(Card, {
        shouldForwardProp: (prop) => prop !== "isSelected"
    })<StyledCardProps>(({theme, isSelected}) => ({
        padding: theme.spacing(4),
        borderRadius: "12px",
        border: "1px solid #DCDCDC",
        ":hover": {
            cursor: "pointer",
            backgroundColor: "#ECECEC"
        },
        boxShadow: "none",
        backgroundColor: isSelected ? "#ECECEC" : 'white',
}))

const WastePointListItem: React.FC<WastePointListItemProps> = ({ wastePointItem, isSelected }) => {  
    const { t } = useTranslation();

    const GetSubTypes = (): string => {
        switch(wastePointItem.type){
            case PoiType.Waste: return wastePointItem.subTypes?.join("; ");
            case PoiType.Drs: return "REpont";
            case PoiType.CustomerService: return wastePointItem.subTypes?.join("; ");
        }
    }

    return (
    <StyledCard isSelected={isSelected}>
        <Grid container direction="column" spacing={1}>
            <Grid item>
                <Typography variant='title'>{wastePointItem.name}</Typography>
            </Grid>
            <Grid item>
                <Divider />
            </Grid>
            <Grid item>
                <Grid container justifyContent="space-between">
                    <Grid item md={3}><Typography variant='subtitle1'>{t("SEARCH_PANEL.CARDS.ADDRESS")}:</Typography></Grid>
                    <Grid item md={9}>
                        <Typography variant='body2'>
                            {`${wastePointItem.address}`}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <Grid container justifyContent="space-between">
                    <Grid item md={3}>
                        <Typography variant='subtitle1'>{t("SEARCH_PANEL.CARDS.TYPE")}:</Typography>
                    </Grid>
                    <Grid item md={9}>
                        <Typography variant='body2'>{GetSubTypes()}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    </StyledCard>
  )
}

export default WastePointListItem